import { TriggerButton } from "@amzn/stencil-react-components/dist/submodules/helpers";
import { Col, Spacer } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC, useState } from "react";

import features from "../../../../public/features/aiforme/features.json";
import FeatureInfo from "./FeatureInfo";

const MONTHS_TO_SHOW = 2; //without counting current month
const FIRST_OF_THE_MONTH = 1;
const MONTHS_TO_ADD = 1;

const FeatureList: FC = () => {
  const [monthsToShow, setMonthsToShow] = useState(MONTHS_TO_SHOW);

  const sortFeatures = features.sort((a, b) => {
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  });

  const now = new Date();
  const cutoffMonth = new Date(now.getFullYear(), now.getMonth() - monthsToShow, FIRST_OF_THE_MONTH);

  const featuresToShow = sortFeatures.filter((feature) => {
    return new Date(feature.date) >= cutoffMonth;
  });

  let currentMonth: string = "",
    currentYear: string = "";

  return (
    <Col padding="S300" width={"100%"}>
      {featuresToShow.map(({ title, description, date }, index) => {
        const printNewMonth =
          new Date(date).toLocaleString("default", { month: "long" }) !== currentMonth ? true : false;
        currentMonth = new Date(date).toLocaleString("default", { month: "long" });

        const printNewYear = new Date(date).getFullYear() !== Number(currentYear) ? true : false;
        currentYear = new Date(date).getFullYear().toString();

        return (
          <Col key={`${date}-${index}`}>
            {printNewYear && (
              <>
                {index > 0 && <Spacer height="S400" />}
                <Text fontSize={"T400"} color="primary70">
                  {new Date(date).getFullYear()}
                </Text>
                <Spacer height="S300" />
              </>
            )}
            {printNewMonth && (
              <>
                {!printNewYear && <Spacer height="S500" />}
                <Text fontSize={"T300"} fontWeight="bold">
                  {new Date(date).toLocaleString("default", { month: "long" })}
                </Text>
                <Spacer height="S100" />
              </>
            )}
            <FeatureInfo title={title} description={description} date={date} index={index} />
          </Col>
        );
      })}
      {features.length - featuresToShow.length > 0 && (
        <>
          <Spacer height="S300" />
          <TriggerButton onClick={() => setMonthsToShow((prev) => prev + MONTHS_TO_ADD)} hasOutline={false}>
            {getString("aiForMe.whatsNew.showMore")}
          </TriggerButton>
        </>
      )}
    </Col>
  );
};

export default FeatureList;
